export class ProductSubscriptions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.initialised = false
    this.productId = Number(this.dataset.productId)

    if (!this.productId) {
      this.throwError('productId is required to set up the Recharge widget')
    }
  }

  setupListeners () {
    super.setupListeners()

    this.setupRechargeWidget = this.setupRechargeWidget.bind(this)

    if (!this.externalEls['product-buy']?.exists) {
      return
    }

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.SUBSCRIPTION_DRAWER_OPENED,
      this.waitForRechargeWidget.bind(this),
    )
  }

  waitForRechargeWidget () {
    const pollForRechargeWidget = () => {
      if (window.ReChargeWidget) {
        this.setupRechargeWidget()
      } else {
        setTimeout(pollForRechargeWidget, 200)
      }
    }

    pollForRechargeWidget()
  }

  setupRechargeWidget () {
    if (this.initialised) return

    if (window.Shopify?.theme?.role === 'development') {
      window.ReChargeWidget.enablePreviewMode()
    }

    const config = {
      productId: this.productId,
      injectionParent: '.rc-widget-injection-parent',
      selectors: {
        price: ['[data-recharge-price]'],
        variant: ['[data-product-buy-el="variant-radios"]'],
      },
    }

    window.ReChargeWidget.createWidget(config)

    this.initialised = true
  }
}

customElements.define('product-subscriptions', ProductSubscriptions)
